<script>
    import {Tabs} from 'flowbite';

    import classnames from 'classnames';

    import {DefaultRideType, RideTypes} from '@js/components/modules/constants';

    import {fetchNearbyRecommendations} from '@js/actions/searchActions';

    import I18n from '@js/modules/translations';

    import {viewport} from '@js/components/themes/actions/viewport';
    import Spinner from '@js/components/themes/Spinner.svelte';

    import RideCard from '@js/components/ride/RideCard.svelte';

    let nearbyRides = $state();

    const _mountTabs = () => {
        const tabsElement = document.getElementById('home-nearby');

        const tabElements = RideTypes.map((rideType) => ({
            id: rideType,
            triggerEl: document.getElementById(`${rideType}-home-nearby-tab`),
            targetEl: document.getElementById(`${rideType}-home-nearby-content`)
        }));

        new Tabs(tabsElement, tabElements, {
            defaultTabId: DefaultRideType,
            activeClasses: 'text-white bg-primary-700 hover:bg-primary-800',
            inactiveClasses: 'text-gray-500 hover:bg-primary-300'
        });
    };

    const _loadNearbyData = () => {
        fetchNearbyRecommendations()
            .then((response) => {
                if (!response) {
                    return;
                }

                nearbyRides = response;
            });
    };

    const _onViewportEnter = () => {
        _loadNearbyData();
    };

    const tabAction = () => {
        $effect(() => {
            _mountTabs();
        });
    };
</script>

<div use:viewport
     onviewportEnter={_onViewportEnter}>
    <div class="main-section mt-24">
        <h2 class="home-title mb-6">
            {I18n.t('js.views.home.nearby.title')}
        </h2>

        <h3 class="mt-6 mb-6 text-xl font-medium text-center">
            {I18n.t('js.views.home.nearby.subtitle')}
        </h3>

        {#if nearbyRides}
            <ul {@attach tabAction}
                id="home-nearby"
                class="flex items-center justify-center flex-wrap text-sm font-medium text-center text-gray-500 dark:text-gray-400"
                data-tabs-toggle="home-nearby-tab-content"
                role="tablist">

                {#each RideTypes as rideType (rideType)}
                    <li class="me-2"
                        role="presentation">
                        <button id={`${rideType}-home-nearby-tab`}
                                class="ml-1 md:ml-4 focus:outline-none focus:ring-2 focus:ring-primary-300 font-medium rounded-lg text-sm px-4 py-2"
                                data-tabs-target={`${rideType}-home-nearby-content`}
                                type="button"
                                role="tab"
                                rel="nofollow, noindex"
                                aria-controls={rideType}
                                aria-selected="false">
                            {I18n.t(`js.ride.enums.ride_type.${rideType}`)}
                        </button>
                    </li>
                {/each}
            </ul>

            <div id="home-nearby-tab-content">
                {#each RideTypes as rideType, i (rideType)}
                    <div class={classnames({hidden: i !== 0})}
                         id={`${rideType}-home-nearby-content`}
                         role="tabpanel"
                         aria-labelledby={`${rideType}-home-nearby-tab`}>
                        <div class="row">
                            {#each nearbyRides[rideType] as ride (ride.id)}
                                <div class="col s12 m6 l4">
                                    <RideCard ride={ride}/>
                                </div>
                            {/each}
                        </div>
                    </div>
                {/each}
            </div>
        {:else}
            <Spinner class="mx-auto center"
                     size="8"
                     color="primary"/>
        {/if}
    </div>
</div>
